import SpbBottomActions from './SpbBottomActions.component';

export default SpbBottomActions;